import { CSSProperties, VFC } from 'react';

import styles from './Spinner.module.scss';

export type SpinnerProps = {
  size: CSSProperties['borderWidth'];
  color?: CSSProperties['borderColor'];
};

const Spinner: VFC<SpinnerProps> = ({ size, color }) => (
  <div
    className={styles.spinner}
    style={{ borderWidth: size, borderLeftColor: color }}
  >
    <span className={styles.text}>Loading...</span>
  </div>
);

export default Spinner;
